export const STRENGTH_CONTENTS = {
    title: 'Top Strengths',
    className: "strength-category"
}

export const DEVELOPMENT_CONTENTS = {
    title: "Top Areas for  Growth",
    className: "development-category "
}

export const HEADER_TEXT = {
    title: "Strengths and areas for growth",
    description: 'The behaviors most frequently voted as top strengths and top growth areas.'
}